import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import { motion } from 'framer-motion';

const FAQPage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />

            {/* Banner Section */}
            <motion.div
                initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                className="relative h-[350px] w-full bg-cover bg-center flex items-center justify-center text-white"
                style={{ backgroundImage: "url('/about-banner.jpg')" }} // Ya koi aur banner image
            >
                <div className="absolute inset-0 bg-black/50" />
                <h1 className="relative text-5xl font-bold z-10">Frequently Asked Questions</h1>
            </motion.div>

            {/* FAQ Component */}
            <FAQ />

            {/* Enquiry Section (Bottom) */}
            <section className="py-20 bg-[#1a2b4d] text-white text-center">
                <div className="max-w-2xl mx-auto px-6">
                    <h3 className="text-3xl font-bold mb-6">Still have questions?</h3>
                    <p className="mb-8 text-gray-300">
                        If you couldn't find the answer you were looking for, please feel free to reach out to our team directly.
                    </p>
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="inline-block" // Ye zaroori hai taki div button ki width le
                    >
                        <Link
                            to="/contact"
                            className="bg-[#f15a24] hover:bg-[#d44d1e] text-white px-10 py-4 font-bold text-lg transition shadow-lg rounded-sm inline-block"
                        >
                            CONTACT OUR TEAM
                        </Link>
                    </motion.div>
                </div>
            </section >

            <Footer />
        </div >

    );
};

export default FAQPage;